import { Typography } from '@mui/material';
import { ErrorStack } from './ErrorStack';

interface Props {
  error: Error;
  showStack?: boolean;
}

export const ErrorMessage = ({ error, showStack = false }: Props) => (
  <>
    <Typography color='error' component='span'>
      error.message
    </Typography>

    {showStack && error.stack && <ErrorStack stack={error.stack} />}
  </>
);
